"use strict";
exports.__esModule = true;
var telegram_chart_1 = require("../telegram-chart");
var min_max_1 = require("../core/min-max");
var padding_1 = require("../core/padding");
var DataFrameMinMax = /** @class */ (function () {
    function DataFrameMinMax() {
        this.x = new min_max_1.MinMax();
        this.y = new min_max_1.MinMax();
    }
    DataFrameMinMax.prototype.clone = function () {
        var c = new DataFrameMinMax();
        c.x = this.x.clone();
        c.y = this.y.clone();
        return c;
    };
    return DataFrameMinMax;
}());
exports.DataFrameMinMax = DataFrameMinMax;
var RenderTarget = /** @class */ (function () {
    function RenderTarget(chart) {
        this.chart = chart;
        this.canvasWidth = null;
        this.canvasHeight = null;
        /**
         * Min and max values for x and y that should be visible on chart.
         */
        this.viewPortDataFrame = new telegram_chart_1.DataToZoomStateMap();
        this.viewPortDataFramePerY = new telegram_chart_1.DataToZoomStateMap();
        this.viewPortDataFrameSaved = new telegram_chart_1.DataToZoomStateMap();
        this.viewPortDataFramePerYSaved = null;
        /**
         * Whether each data type on this render target should be rendered in it's own scale.
         */
        this.viewPortScalePerY = false;
        /**
         * Min and max values for x and y calculated from data.
         */
        this.dataFrame = new telegram_chart_1.DataToZoomStateMap();
        this.dataFramePerY = new telegram_chart_1.DataToZoomStateMap();
        /**
         * Whether to render labels on y axis
         */
        this.yLabelsEnabled = false;
        this.yLabels = [];
        /**
         * Controls what data values should be visible on chart.
         */
        this.yVisibility = {};
        /**
         * Controls opacity for each line
         */
        this.yOpacity = {};
        this.yOpacityAnimations = {};
        this.lineWidth = 1.5 * window.devicePixelRatio;
        this.xLabelsEnabled = false;
        this.xLabels = [];
        this.quality = 5;
        this.autoAdjustYMax = true;
        this.autoAdjustYMin = false;
        this.viewPortPadding = new padding_1.Padding();
        this.viewportChanged = true;
        this.features = [];
    }
    RenderTarget.prototype.addFeature = function (f) {
        f.onAttach(this);
        this.features.push(f);
    };
    RenderTarget.prototype.onDataChange = function () {
        for (var i = 0; i < this.features.length; i++) {
            this.features[i].onDataChange();
        }
    };
    RenderTarget.prototype.onResize = function () {
        for (var i = 0; i < this.features.length; i++) {
            this.features[i].onResize();
        }
    };
    RenderTarget.prototype.onYMinMaxChange = function (newYMin, newYMax, yId) {
        if (yId === void 0) { yId = null; }
        for (var i = 0; i < this.features.length; i++) {
            this.features[i].onYMinMaxChange(newYMin, newYMax, yId);
        }
    };
    RenderTarget.prototype.renderBackground = function () {
        for (var i = 0; i < this.features.length; i++) {
            this.features[i].renderBackground();
        }
    };
    RenderTarget.prototype.renderForeground = function () {
        for (var i = 0; i < this.features.length; i++) {
            this.features[i].renderForeground();
        }
    };
    return RenderTarget;
}());
exports.RenderTarget = RenderTarget;
//# sourceMappingURL=render-target.js.map